export enum MinMaxSource {
	USER = 'user',
	M3 = 'm3',
	SITE = 'site'
}
